// Stage-aging visual states for pipeline cards. Item 1.14 (§3.14). Sprint B
// uses hardcoded thresholds; Sprint D's migration 024 introduces a
// pipeline_aging_config table + admin settings UI for per-stage tunable
// thresholds. The shape returned here is the same either way so the card
// component doesn't need to change when the data source flips.

const DEFAULT_WARNING_DAYS = 14;
const DEFAULT_CRITICAL_DAYS = 30;

// Returns one of 'normal' | 'warning' | 'critical'. Returns 'normal' when the
// timestamp is missing (a brand-new account that just entered the stage today
// has no entered_at yet on the row in some race conditions — treat as fresh).
export function agingTone(stageEnteredAt, now = Date.now(), {
  warningDays = DEFAULT_WARNING_DAYS,
  criticalDays = DEFAULT_CRITICAL_DAYS,
} = {}) {
  if (!stageEnteredAt) return 'normal';
  const t = Date.parse(stageEnteredAt);
  if (!Number.isFinite(t)) return 'normal';
  const daysIn = Math.floor((now - t) / 86400000);
  if (daysIn >= criticalDays) return 'critical';
  if (daysIn >= warningDays) return 'warning';
  return 'normal';
}

// Tailwind border classes per tone — paired with the card component.
export const AGING_BORDER_CLASS = {
  normal: 'border-white/[0.06]',
  warning: 'border-amber-500/40',
  critical: 'border-red-500/50',
};
